import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { dkorderList, expressQuery, qiWeiPasswordLogin, qiWeiUserIdToToken } from '@/api';
import { invoke } from 'wecom-sidebar-jssdk';
import Cookies from 'js-cookie';
import { Tabs, message, Descriptions, Card, Table, Form, Row, Col, Input, Button, Select, Divider, Space, Modal } from 'ant-design-vue';
let ExternalUser = class ExternalUser extends Vue {
    constructor() {
        super(...arguments);
        this.user = null;
        this.externalUser = {};
        this.activeKey = '1';
        this.tokens = '';
        this.userId = '';
        this.expressQueryData = {};
        this.open = false;
        this.orderListData = {
            list: []
        };
        this.searchForm = {
            page: 1,
            page_size: 10,
            external_userid: '',
            order_sn: '',
            order_status: -1
        };
        this.crmLogin = {
            username: '',
            password: '',
            qw_user_id: '',
        };
    }
    onClose() {
        this.open = false;
    }
    async onShow(order_id) {
        const res = await invoke('getCurExternalContact', {});
        if (!res || !res.userId)
            return;
        console.log('外部联系人 ID', res.userId);
        this.expressQueryData = await expressQuery({
            order_id: order_id,
            external_userid: res.userId
        });
        this.open = true;
    }
    async getOrderList() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.searchForm.external_userid = res.userId;
            this.orderListData = await dkorderList(this.searchForm);
        }
        catch (e) {
            message.error(e);
        }
    }
    async qiWeiPasswordLogin() {
        let res = await qiWeiPasswordLogin(this.crmLogin);
        console.log(res);
        if (res.code == 0) {
            this.tokens = res.data;
            window.open(`https://scrm.tangzhiguanjia.com?token=${res.data.token}`, "newWindow", "width=500,height=500");
        }
        else {
            message.error(res.message);
        }
    }
    async qiWeiUserIdToToken() {
        try {
            const userIds = Cookies.get('userId');
            if (userIds) {
                this.crmLogin.qw_user_id = userIds;
            }
            const token = await qiWeiUserIdToToken({
                qw_user_id: userIds
            });
            if (token.code === 401000) {
                console.log('token', token);
            }
            else {
                this.tokens = token.data;
            }
        }
        catch (e) {
            message.error(e);
        }
    }
    async mounted() {
        await this.getOrderList();
        await this.qiWeiUserIdToToken();
    }
};
ExternalUser = __decorate([
    Component({
        name: 'ExternalUser',
        components: {
            'a-modal': Modal,
            'a-divider': Divider,
            'a-space': Space,
            'a-tabs': Tabs,
            'a-card': Card,
            'a-tab-pane': Tabs.TabPane,
            'a-descriptions': Descriptions,
            'a-descriptions-item': Descriptions.Item,
            'a-table': Table,
            'a-form': Form,
            'a-form-item': Form.Item,
            'a-row': Row,
            'a-col': Col,
            'a-input': Input,
            'a-button': Button,
            'a-select': Select,
            'a-select-option': Select.Option,
        }
    })
], ExternalUser);
export default ExternalUser;
